import React from 'react';
import { compose, withHandlers } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core';
import Container from '@material-ui/core/Container';

const styles = theme => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white
    }
  },
  textCenter: {
    textAlign: 'center',
    fontSize: 20,
    marginTop: 20
  },
  imageMaintain: {
    width: 300,
    height: 300,
    objectFit: 'cover'
  },
  center: {
    textAlign: 'center'
  },
  maintainCnt: {
    textAlign: 'left',
    fontSize: 14,
    margin: '20px 0px'
  }
});

const enhancer = compose(
  withHandlers({
    handleRedirect: props => path => {
      props.history.push(path);
    }
  })
);

const smsAuth = enhancer(({ classes }) => {
  return (
    <Container component="main" maxWidth="xs">
      <div className={classes.center}>
        <img
          src="/images/gochi_logo_print.png"
          alt="The website under maintenance"
          width="100%"
          className={classes.imageMaintain}
        />

        <div className={classes.maintainCnt}>
          {/* エラーが発生しました。時間をおいてお試しください。 */}
          ただいまシステムに内部の構成変更に伴うメンテナンスのため、一時的にサービスの機能を全て停止しております。大変ご不便をおかけいたしますが、今しばらくお待ちください。
          <br />
          <br />
          <b>【メンテナンス作業予定日時】</b>
          <br />
          2024年2月21日（水）
          <b>20:00</b>
          <span> ~ 2月22日（木）</span>
          <b>08:00</b>
          <br />
          ※メンテナンス作業が終了次第公開いたします。
          <br />
          <br />
          <b>【お問い合わせ】</b>
          <br />
          <a
            className="text-green"
            target="_blank"
            rel="noopener noreferrer"
            href="https://support.gigi.tokyo/contact/contact01/"
          >
            https://support.gigi.tokyo/contact/contact01/
          </a>
        </div>
      </div>
    </Container>
  );
});

export default withRouter(withStyles(styles)(smsAuth));
